import { FundRequestContext, type IFundRequestContext } from 'BreetComponents';
import { useContext } from 'react';

export const useFundRequestContext = (): IFundRequestContext => {
	const fundRequestContext = useContext(FundRequestContext);

	if (!fundRequestContext) {
		throw new Error('useFundRequestContext must be used within FundRequestProvider');
	}

	return fundRequestContext;
};
